<customer-menu
  *ngIf="refreshService.selectedRefreshTime$ | async as refreshTime"
  class="asList"
  [value]="refreshTime.value">
  <customer-menu-item
    *ngFor="let refreshOption of REFRESH_OPTIONS"
    [value]="refreshOption.value"
    (click)="refreshService.setNewInterval(refreshOption.value)">
    <span>{{ refreshOption.label }}</span>
  </customer-menu-item>
</customer-menu>
